import dayjs from 'dayjs';

import {
  SHORT_MONTH_DAY_FORMAT,
  SHORT_MONTH_DAY_YEAR_FORMAT,
  SHORT_TIME_FORMAT,
} from 'constants/date';

import { HEADER_CHAT_MENTION_PREVIEW_MAX_CHARS } from '../HeaderChatPopover/HeaderChatPopover.constants';

export const truncatePreview = text => {
  if (!text) {
    return '';
  }

  if (text.length <= HEADER_CHAT_MENTION_PREVIEW_MAX_CHARS) {
    return text;
  }

  return `${text.slice(0, HEADER_CHAT_MENTION_PREVIEW_MAX_CHARS - 1)}…`;
};

export const formatMentionTimestamp = timestamp => {
  if (!timestamp) {
    return '';
  }

  const date = dayjs(timestamp);

  if (!date.isValid()) {
    return '';
  }

  const now = dayjs();

  if (date.isSame(now, 'day')) {
    return date.format(SHORT_TIME_FORMAT);
  }

  if (date.isSame(now, 'year')) {
    return date.format(SHORT_MONTH_DAY_FORMAT);
  }

  return date.format(SHORT_MONTH_DAY_YEAR_FORMAT);
};
